export default __webpack_public_path__ + "static/media/bgTop.11f1db5d.jpg";